export type Project = {
  id: number
  name: string
  code: string
  status: number
  subprojectCount: number
  subCount: number
  progress: number
  timeProgress: number
  unitsPredicted: number
  unitsUsed: number
  unitsDone: number
  unitsDiff: number
  salaryPredicted: number
  salaryUsed: number
  salaryDone: number
  salaryDiff: number
  timePredicted: number
  timeUsed: number
  timeDone: number
  timeDiff: number
  difficulty: number
  shift: number
  shiftsPerDay: number
  concurrentShifts: number
  workers: number
  parentId?: number
  parentName?: string
  plannedAt?: string
  plannedTo?: string
}

export enum TaskStatus {
  Created = 0,
  Approved = 1,
  StatusToStarted = 2,
  StatusToDone = 3,
  Error = 4,
  ErrorAck = 5,
}

export type Task = {
  opGroupName?: string
  target?: string
  id: number
  user?: {
    id: number
    name: string
  }
  worker: {
    id: number
    name: string
  }
  workerName: string
  operationId: number
  operationName: string
  parentProject: {
    id: number
    name: string
    code: string
  }
  project: {
    id: number
    name: string
    code: string
  }
  projectName: string
  projectId: number
  subProjectId: number
  districtId?: number
  opGroupId: number
  timePredicted: number
  subProjectName: string
  operation: {
    id: number
    name: string
    workerCount: number
  }
  timeUsed: number
  timeExpected: number
  date: string
  createdAt: number
  deletedAt: number
  deletedBy?: number
  deletedByName?: string
  deletedComment?: string
  unitsUsed: number
  opUnitsUsed?: number
  unitsPredicted: number
  expenseSum: number
  approved: false
  salaryUsed: number
  salaryPredicted: number
  salary: string
  status: TaskStatus
  comment: null | string
  normative: number
  defect: boolean
}
export type Group = {
  id: number
  name: string
  status: number
  operations: Operation[]
}

export type Operation = {
  createdAt: string
  id: number
  opGroup: {
    id: number
    name: string
    parentId: number
    createdAt: string
  }
  name: string
  opGroupId: number
  projectId: number
  status: number
  tenantId: number
  tenantUserId: number
  timePredicted: number
  timeUsed: number
  unitsPredicted: number
  unitsUsed: number
  salaryUsed: number
  salaryPredicted: number
  workerCountExpected: number
  workerCountUsed: number
  normative?: number
  plannedAt?: string
  plannedTo?: string
}
export type OpGroup = {
  id: number
  name: string
  operations: {
    id: number
    name: string
  }[]
}
export type District = {
  id: number
  tenantId: number
  name: string
  workers: number
  shift: number
  concurrentShifts: number
  shiftsPerDay: number
  status: number
  deletedAt: number
  createdAt: number
  updatedAt: number
  users?: Pick<Worker, "id" | "name">[]
}
export enum UserRole {
  Empty = 0,
  User = 1 << 0, // 1
  Admin = 1 << 1, // 2
  SuperAdmin = 1 << 2, // 4
  Manager = 1 << 3, // 8
}
export type PermissionItem = {
  id: number
  name: string
}
export type Worker = {
  id: number
  name: string
  email: string
  username: string
  coeficient: number
  errorCount: number
  role: UserRole
  changePasswordUrl?: string
  urlExpireAt?: string
  permissions: {
    projects: PermissionItem[]
    opGroups: PermissionItem[]
    districts?: PermissionItem[]
  }
  lastLoginAt?: string
}

export type Message = {
  id: number
  fromUserId?: number
  fromUser?: {
    id: number
    name: string
    username: string
  }
  content: string
  createdAt: string
  updatedAt?: string
  deletedAt?: string
  systemMessage: boolean
  attachments: MessageAttachment[]
  recipients: MessageRecipient[]
  districtIds?: string
}

export type MessageAttachment = {
  id: number
  messageId: number
  path: string
  name: string
  mimeType: string
  createdAt: string
  url: string
}

export type MessageRecipient = {
  id: number
  messageId: number
  toUserId: number
  toUser?: {
    id: number
    name: string
    username: string
  }
  createdAt: string
  deletedAt?: string
  readAt?: string
}

export type MessagePerRecipientWithAttahcments = {
  id: number
  messageId: number
  fromUserId?: number
  fromUserName?: string
  toUserId: number
  toUserName: string
  content: string
  createdAt: string
  updatedAt?: string
  deletedAt?: string
  readAt?: string
  systemMessage: boolean
  attachments: MessageAttachment[]
}
